
	import ViewBase from '@/View/Base';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt.kenefick@buck.co>
	 * @package View/Button
	 * @project buck-impact-2024
	 */
	@Component
	export default class ViewButtonHome extends ViewBase {
		// Not implemented
	}
